{
    "1Oc1u": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "1Oc1u",
        "tag": "goodspawn"
    },
    "Vlpnq": {
        "position": {
            "x": 10,
            "y": 7,
            "z": 1
        },
        "key": "Vlpnq",
        "tag": "goodspawn"
    },
    "Dt2qO": {
        "position": {
            "x": 11,
            "y": 7,
            "z": 1
        },
        "key": "Dt2qO",
        "tag": "goodspawn"
    },
    "tqxRi": {
        "position": {
            "x": 30,
            "y": 9,
            "z": 1
        },
        "key": "tqxRi",
        "tag": "goodspawn"
    },
    "mjguU": {
        "position": {
            "x": 30,
            "y": 8,
            "z": 1
        },
        "key": "mjguU",
        "tag": "goodspawn"
    },
    "uLlnC": {
        "position": {
            "x": 29,
            "y": 9,
            "z": 1
        },
        "key": "uLlnC",
        "tag": "goodspawn"
    },
    "WTnEW": {
        "position": {
            "x": 29,
            "y": 8,
            "z": 1
        },
        "key": "WTnEW",
        "tag": "goodspawn"
    },
    "FkzvE": {
        "position": {
            "x": 52,
            "y": 9,
            "z": 1
        },
        "key": "FkzvE",
        "tag": "goodspawn"
    },
    "Pmb8b": {
        "position": {
            "x": 52,
            "y": 10,
            "z": 1
        },
        "key": "Pmb8b",
        "tag": "goodspawn"
    },
    "CxCPt": {
        "position": {
            "x": 52,
            "y": 11,
            "z": 1
        },
        "key": "CxCPt",
        "tag": "goodspawn"
    }
}